import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UpperCasePipe } from '@angular/common';

import { NgIcon } from '@ng-icons/core';
import { LanguageVersion } from '../../../../shared/model/local/config/language-version';
import { ApplicationFacadeService } from '../../../../shared/service/application-facade.service';
import { ClickOutsideDirective } from '../../../../shared/directive/click-outside.directive';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [UpperCasePipe, ClickOutsideDirective, NgIcon],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  private appFacade = inject(ApplicationFacadeService);

  languages = [LanguageVersion.EN, LanguageVersion.DE, LanguageVersion.ES];
  language = toSignal(this.appFacade.language$);

  isDropdownOpen = false;

  changeLanguage(lang: LanguageVersion) {
    this.appFacade.changeLanguage(lang);
    this.isDropdownOpen = false;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }
}
